import Link from "next/link"
import { type ReactNode } from "react"
import { Button } from "~/components/ui/button"
import { cn } from "~/lib/utils"
import { FacebookIcon, InstagramIcon, YoutubeIcon } from "lucide-react";

interface NotFoundProps {
    className?: string
    title: string
    description: string
    content?: ReactNode
    titleClassName?: string
    descriptionClassName?: string
    notDescription?: string
    notDescriptionClassName?: string
    homeButton?: boolean | undefined | null
    notFound?: boolean | undefined | null
}

const NotFound = ({ className, title, description, content, titleClassName, descriptionClassName, homeButton, notDescription, notDescriptionClassName, notFound }: NotFoundProps) => {
    const link = [
        { site: "https://www.facebook.com/devmobilechas/", icon: FacebookIcon, color: "text-blue-500" },
        { site: "https://www.instagram.com/devmobilechas/", icon: InstagramIcon, color: "text-pink-500" },
        { site: "https://www.youtube.com/@devmobilechas?sub_confirmation=1", icon: YoutubeIcon, color: "text-red-500" }
    ]
    return (
        <div className={cn("flex size-full flex-col items-center justify-center py-16", className)}>
            {content && (
                <div className="bg-accent size-20 rounded-full p-4">
                    {content}
                </div>
            )}
            <span className={cn("mb-1 text-center text-2xl font-bold", titleClassName)}>{title}</span>
            <span className={cn("mb-4 text-center", descriptionClassName)}>{description}</span>
            {notFound && (
                <>
                    <span className={cn("mb-2 text-center", notDescriptionClassName)}>{notDescription}</span>
                    <div className="flex gap-2 mb-4">
                        {link.map((item, index) => (
                            <Link href={item.site} target="_blank" key={index}>
                                <Button size="icon" variant="ghost" className={cn("rounded-full", item.color)}>
                                    <item.icon />
                                </Button>
                            </Link>
                        ))}
                    </div>
                </>
            )}
            {homeButton && (
            <Link href="/" className="flex justify-center">
                <Button className="rounded-lg">Go To Home</Button>
            </Link>
      )}
        </div>
    )
}

export { NotFound }

